import React from 'react';
import { Box } from '../../../../../../../../CommonComponents/OPL/Box/Box';
import { Card } from '../../../../../../../../CommonComponents/OPL/Card/Card';
import { Text } from '../../../../../../../../CommonComponents/OPL/Text/Text';
import { TextLoading } from '../../../../../../../../CommonComponents/OPL/Text/Text.loading';
import { PieChartLoading } from '../../../../../../../../CommonComponents/OPL/charts/PieChart/PieChart.loading';

export const HeaderLoading = () => (
  <Box display="flex" mt="16" alignItems="stretch">
    <Box width="100%" mr="8" mb="8" display="flex" flexDirection="column">
      <Card p="16" height="100%">
        <Text variant="cardTitle" mb="16">
          Monte Carlo
        </Text>

        <Text variant="smallCaps" mb="8">
          fully funded at retirement
        </Text>

        <TextLoading height="h3" width={60} mb="8" />

        <Text variant="smallCaps" mb="8">
          money ran out
        </Text>

        <TextLoading height="h3" width={60} mb="16" />
      </Card>
    </Box>
    <Box width="100%" ml="8" mb="8" display="flex" flexDirection="column">
      <Card p="16" height="100%">
        <Text variant="cardTitle">Probability of success</Text>
        <Box display="flex" alignItems="center" justifyContent="center" flex="1" height="100%">
          <Box width="86px" height="86px">
            <PieChartLoading hasTitle />
          </Box>
          <Text ml="16" color="neutral.500" fontWeight={500} fontSize="small" variant="tabular">
            Target: 70-99%
          </Text>
        </Box>
      </Card>
    </Box>
  </Box>
);
